import React from 'react';
import usePageTitle from '../hooks/usePageTitle';
import { useLanguage } from '../contexts/LanguageContext';
import GameLayout from './GameLayout';
import CatchMe from './CatchMe';

const CatchMePage = () => {
  const { t } = useLanguage();
  usePageTitle(t('trivia.tabCatch'));

  return (
    <GameLayout title={t('trivia.tabCatch')} emoji="✋🏆">
      <CatchMe />
    </GameLayout>
  );
};

export default CatchMePage;
